export default function dashIfUndefined(value: any) {
    return value === null || value === undefined || value === '' ? '-' : value
}
